// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_Ech","cls2":"PremiumBadge-cls2_VmD PremiumBadge-cls1_Ech"};